<template>
  <v-dialog v-model="dialog" max-width="100%">
    <v-card>
      <v-toolbar :color="colorDialogTitle" dark>{{ formTitle }}</v-toolbar>
      <v-container fluid>
        <!-- <v-form ref="form" v-model="formValid" lazy-validation> -->
        <template v-if="tipoConsulta == 1">
          <v-form ref="form" lazy-validation>
            <v-row justify="center" class="mt-4">
              <v-col cols="12" sm="6">
                <v-select
                  v-model="contratistaSeleccion"
                  :items="contratistas"
                  item-value="idContratista"
                  item-text="descripcionContratista"
                  :menu-props="{ maxHeight: '400' }"
                  :readonly="readonlyContrator"
                  prepend-icon="mdi-badge-account-outline"
                  label="Contratistas"
                  no-data-text="No se encontraron contratistas"
                  hint="Seleccione un Contratistas"
                  persistent-hint
                ></v-select>
              </v-col>
            </v-row>

            <v-row justify="center" class="mt-4">
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="idOT"
                  prepend-icon="mdi-note"
                  label="Codigo OT"
                  hint="Ingrese el codigo de OT para el Contratista"
                  persistent-hint
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip color="#cecaff" v-if="index < 2">
                      <span>{{ item.nombreCompleto }}</span>
                    </v-chip>
                    <span
                      v-if="
                        index === empleadoSeleccionados.length - 1 &&
                        empleadoSeleccionados.length > 2
                      "
                      class="grey--text text-caption"
                    >
                      ({{ txtEmpleado }})
                    </span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </template>

        <template v-if="tipoConsulta == 2">
          <v-data-table
            :headers="headers"
            :items="listaMateriales"
            item-key="idCajon"
            sort-by="idCajon"
            :search="buscar"
            :header-props="headerProps"
            :footer-props="$store.state.traduccionTabla"
            no-data-text="No se encontraron registros"
            no-results-text="No se encontraron registros en la búsqueda"
          >
          </v-data-table>
        </template>

        <AlertSnackBar ref="AlertSnackBar" color="#7bae00"></AlertSnackBar>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-if="tipoConsulta == 1">
          <v-btn color="blue darken-1" text @click="ingresarOTContratista"
            >Aceptar</v-btn
          >
        </template>

        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
//import sha512 from "js-sha512";
export default {
  data() {
    return {
      idOT: "",
      contratistaSeleccion: "",
      dialog: false,
      colorDialogTitle: "",
      formTitle: "",
      headers: [
        {
          text: "Id",
          align: "start",
          sortable: true,
          value: "idMaterial",
          class: "black white--text",
        },
        { text: "Descripción", value: "nombre", class: "black white--text" },
        {
          text: "Cantidad Inicial",
          value: "cantidadInicial",
          class: "black white--text",
        },
        {
          text: "Cantidad Actual",
          value: "cantidadActual",
          class: "black white--text",
        },
      ],
    };
  },

  mounted() {
    console.log("Ingreso en modalContratistas");
    this.getListarContratistas();
    //this.getDetallesMateriales();
  },

  methods: {
    async getDetallesMateriales() {
      this.listaMateriales = [];

      console.log("Ingreso en los detalles de la OT");
      this.url =
        this.$store.getters.urlBase +
        "Material/recuperarMaterialesOperadorXOT?idOT=" +
        this.idOT;

      console.log("La idOT es");
      console.log(this.url);

      var listaCajon = [];
      this.cajones = listaCajon;

      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar materiales cajon");
          console.log(response.data);
          this.listaMateriales = response.data;
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.listaMateriales = respuesta;
      console.log("Los datos de la lista de materiales es");
      console.log(this.listaMateriales);

      this.loadingButton = false;
      this.dialog = false;
      this.dialog = true;
      this.getDetallesCuadrilla();
    },

    abrirModalContratistaMateriales(datos) {
      this.tipoConsulta = 2;
      this.dialog = true;
      this.colorDialogTitle = "blue";
      this.formTitle = "Materiales de la OT Nº " + datos.ord_ot;
      this.idOT = datos.ord_ot;
      this.getDetallesMateriales();
    },

    openModal() {
      this.tipoConsulta = 1;
      this.dialog = true;
      this.colorDialogTitle = "indigo";
      this.formTitle = "Asignar OT a Contratista";
    },

    close() {
      this.dialog = false;
    },

    async ingresarOTContratista() {
      this.url = this.$store.getters.urlBase + "OT/ingresarOTContratista";

      const data = {
        IdContratista: this.contratistaSeleccion,
        IdOT: this.idOT,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("El arreglo de datos tiene esto:");
      console.log(data);

      await axios
        .post(this.url, data)
        .then((response) => {
          console.log(response.data);
          this.contratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    async getListarContratistas() {
      // this.url = "https://localhost:5001Contractor/getlistado";
      this.url =
        this.$store.getters.urlBase +
        "Contractor/recuperarContratistasAsociados?idUsuario=" +
        this.$store.getters.usuario.user_id;
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      var listacontratista = [];
      this.contratistas = listacontratista;

      await axios
        .get(this.url)
        .then((response) => {
          console.log(response.data);
          this.contratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    //async recuperar
  },
};
</script>
>
